// Super Admin data management (2 November 2026; migrations 059 and 060; docs/data-management.md). Arabic needs review by an
// Arabic copy editor.
export const DATA_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    bdTab_data: "Data management",
    dmIntro: "Remove chosen data of this business only. Preview what would go, download the export, then confirm with your password and the business's name. Other businesses, the audit trails, billing history and reseller records are never touched.",
    dmNeverDeleted: "The business record itself is never deleted: the platform audit log, subscriptions and reseller statements refer to it. Choose below whether it stays open or is suspended.",
    dmStep0: "1. Stop the business's sales and settle its registers",
    dmFreezeIntro: "Before anything is exported or removed, the business's sales stop: no sale or refund, no offline grant or ticket. Every register that sold offline must reconnect, send its saved sales and confirm its queue is empty. The export can only be made once every register is confirmed (or written off) and every offline sale is completed or reviewed.",
    dmFreezeReason: "Why (for the audit log)",
    dmFreeze: "Stop sales",
    dmFrozen: "Sales stopped on {at} by {by}. No sale, refund, offline grant or ticket can be made until you release them.",
    dmFrozenAfter: "The data was removed. Sales stay stopped until you release them (release only once the business may trade again).",
    dmRegister: "Register",
    dmRegState: "State",
    dmRegSeen: "Last sale received",
    dmReg_waiting: "Waiting: it must reconnect, send its sales and confirm",
    dmReg_confirmed: "Confirmed: queue checked, closed",
    dmReg_refused: "Holds {n} sales Delta refused: kept in full; decide, then write off",
    dmReg_written_off: "Written off",
    dmWriteOffNote: "Reason (at least 10 characters)",
    dmWriteOff: "Write off",
    dmBlocked: "The export is not possible yet",
    dmBlock_no_freeze: "The business's sales are not stopped.",
    dmBlock_register_waiting: "Register {c} has not confirmed its queue. It confirms by itself once it reconnects (the Windows app checks every minute). If it cannot reconnect, write it off with the reason.",
    dmBlock_register_refused: "Register {c} holds sales Delta refused. They are recorded in full; once they are dealt with, write it off with the reason.",
    dmBlock_sales_unresolved: "{n} offline sales are received but not completed or reviewed. Complete or review them in POS › Review (the business's administrator).",
    dmReady: "Every register is confirmed or written off and every offline sale is settled: the export can be made.",
    dmLostRegister: "A register that is lost or broken: write it off with the reason. Its sales are never deleted from it; if it is found, connect it and Delta holds what it sends for review (see the guide).",
    dmRelease: "Release sales",
    dmRefresh: "Refresh",
    dmExportNeedsFreeze: "The export is made only after step 1 is complete.",
    dmNotReady: "Registers or offline sales still need attention (step 1). Nothing was exported.",
    dmRestored: "restored {at}",
    dmStep1: "2. What to remove",
    dmAll: "All business data",
    dmCat_transactions: "Transactions: invoices, payments, vouchers, journal entries, stock movements and balances, fixed assets, POS shifts and offline sales, print records, legacy history",
    dmCat_items: "Items: items, units of items, barcodes, pictures, categories, imports",
    dmCat_parties: "Customers, suppliers and partners (the POS walk-in customer stays while the business stays open)",
    dmCat_pos: "Registers: POS registers, activation codes, payment buttons",
    dmCat_users: "Users: switched off and signed out (kept as names in the audit trail), with their rights",
    dmCat_setup: "Setup: chart of accounts, branches, warehouses, cash drawers and banks, taxes, cost centers, numbering, settings, logo (only with all data and a suspended business)",
    dmChoices: "Explicit choices",
    dmBusiness: "The business",
    dmBusiness_keep: "Stays open (its owner signs in again)",
    dmBusiness_suspend: "Suspended (nobody can sign in; the record stays)",
    dmOwner: "Owner's login",
    dmOwner_keep: "Kept",
    dmOwner_remove: "Switched off (only with Users and a suspended business)",
    dmSub: "Package and subscription",
    dmSub_keep: "Stay in force",
    dmSub_end: "End now (kept as billing history)",
    dmPreview: "Preview",
    dmStep2: "3. Preview",
    dmRows: "{n} records would be removed",
    dmTable: "Table",
    dmCategory: "Category",
    dmCount: "Records",
    dmKept: "Always kept",
    dmKept_organization: "Business record",
    dmKept_audit_log: "Business audit log",
    dmKept_platform_audit_log: "Platform audit log",
    dmKept_subscriptions: "Subscriptions (billing history)",
    dmKept_reseller_records: "Reseller assignments, rates and charges",
    dmKept_requests: "Signup and subscription requests",
    dmKept_users: "Users still able to sign in",
    dmInFlight: "Now: {s} signed-in sessions, {g} live offline grants, {u} offline sales received but not completed, {r} active registers. Sessions are signed out by the removal; registers are switched off when transactions are removed.",
    dmPosted: "{n} posted or issued records are included (invoices, vouchers, journal entries, stock documents). Businesses in Saudi Arabia must keep accounting records and tax invoices for a legal retention period (VAT records at least six years; commercial books may need longer). Confirm the period with the business and keep the export safely before removing them.",
    dmProblems: "This combination cannot be removed as chosen",
    dmProb_setup_needs_suspend: "Setup can only be removed when the business is suspended.",
    dmProb_setup_needs_all: "Setup can only be removed with all business data.",
    dmProb_owner_needs_suspend_and_users: "The owner's login can only be switched off with Users and a suspended business.",
    dmProb_demo_business: "This is a demo business: demos are removed automatically when they end.",
    dmNeeds: "{t} ({n} records) refers to what you chose: add {c}.",
    dmStep3: "4. Export",
    dmExport: "Download the export",
    dmExported: "Export downloaded: {b} bytes, SHA-256 {h}. Keep it safe: it is the way back (the restore command in the guide checks it against this checksum).",
    dmStep4: "5. Confirm",
    dmTypeName: "Type the business's name: {x}",
    dmPassword: "Your Delta Platform password",
    dmAckRetention: "The export is kept and the business's record-retention obligations are met.",
    dmRemove: "Remove the data",
    dmDone: "Removed. {n} records; export SHA-256 {h}.",
    dmHistory: "Earlier exports and removals",
    dmStatus_exported: "Exported, not removed",
    dmStatus_done: "Removed",
    dmStatus_failed: "Failed",
    dmStatus_running: "Running",
    dmStale: "The data changed: preview and export again."
  },
  ar: {
    bdTab_data: "إدارة البيانات",
    dmIntro: "احذف بيانات مختارة من هذه المنشأة فقط. اعرض ما سيُحذف، ونزّل نسخة التصدير، ثم أكّد بكلمة مرورك واسم المنشأة. لا تُمس المنشآت الأخرى ولا سجلات التدقيق ولا سجل الفوترة ولا سجلات الموزعين.",
    dmNeverDeleted: "لا يُحذف سجل المنشأة نفسه أبدًا: يشير إليه سجل تدقيق المنصة والاشتراكات وكشوف الموزعين. اختر أدناه هل تبقى مفتوحة أم تُعلّق.",
    dmStep0: "1. إيقاف مبيعات المنشأة وتسوية نقاط البيع",
    dmFreezeIntro: "قبل أي تصدير أو حذف تتوقف مبيعات المنشأة: لا بيع ولا مرتجع ولا تصريح أو تذكرة بيع دون اتصال. يجب أن تتصل كل نقطة بيع باعت دون اتصال وترسل مبيعاتها المحفوظة وتؤكد أن قائمتها فارغة. لا يتاح التصدير إلا بعد تأكيد كل نقطة بيع (أو شطبها) وإتمام كل بيع دون اتصال أو مراجعته.",
    dmFreezeReason: "السبب (لسجل التدقيق)",
    dmFreeze: "إيقاف المبيعات",
    dmFrozen: "أوقفت المبيعات في {at} بواسطة {by}. لا بيع ولا مرتجع ولا تصريح أو تذكرة دون اتصال حتى تعيد تفعيلها.",
    dmFrozenAfter: "حُذفت البيانات. تبقى المبيعات موقوفة حتى تعيد تفعيلها (أعدها فقط حين يجوز للمنشأة أن تبيع من جديد).",
    dmRegister: "نقطة البيع",
    dmRegState: "الحالة",
    dmRegSeen: "آخر بيع وصل",
    dmReg_waiting: "بانتظارها: يجب أن تتصل وترسل مبيعاتها وتؤكد",
    dmReg_confirmed: "مؤكدة: فُحصت قائمتها وأُغلقت",
    dmReg_refused: "تحمل {n} عملية بيع رفضتها دلتا: محفوظة كاملة؛ قرّر ثم اشطبها",
    dmReg_written_off: "مشطوبة",
    dmWriteOffNote: "السبب (10 أحرف على الأقل)",
    dmWriteOff: "شطب",
    dmBlocked: "لا يمكن التصدير بعد",
    dmBlock_no_freeze: "مبيعات المنشأة غير موقوفة.",
    dmBlock_register_waiting: "نقطة البيع {c} لم تؤكد قائمتها. تؤكد تلقائيًا عند اتصالها (يفحص تطبيق ويندوز كل دقيقة). إن تعذر اتصالها فاشطبها مع ذكر السبب.",
    dmBlock_register_refused: "نقطة البيع {c} تحمل مبيعات رفضتها دلتا. سُجّلت كاملة؛ بعد معالجتها اشطب نقطة البيع مع ذكر السبب.",
    dmBlock_sales_unresolved: "{n} عملية بيع دون اتصال وصلت ولم تُتمّ أو تُراجع. يتمّها أو يراجعها مسؤول المنشأة من نقطة البيع › المراجعة.",
    dmReady: "كل نقاط البيع مؤكدة أو مشطوبة وكل مبيعات دون اتصال مسوّاة: يمكن التصدير.",
    dmLostRegister: "نقطة بيع مفقودة أو معطلة: اشطبها مع ذكر السبب. لا تُحذف مبيعاتها منها أبدًا؛ إن وُجدت فاوصلها وتحتجز دلتا ما ترسله للمراجعة (انظر الدليل).",
    dmRelease: "إعادة تفعيل المبيعات",
    dmRefresh: "تحديث",
    dmExportNeedsFreeze: "لا يُصدّر إلا بعد إتمام الخطوة 1.",
    dmNotReady: "ما زالت نقاط بيع أو مبيعات دون اتصال تحتاج إلى معالجة (الخطوة 1). لم يُصدّر شيء.",
    dmRestored: "استُرجعت {at}",
    dmStep1: "2. ما الذي يُحذف",
    dmAll: "كل بيانات المنشأة",
    dmCat_transactions: "الحركات: الفواتير والمدفوعات والسندات والقيود وحركات المخزون وأرصدته والأصول الثابتة وورديات نقاط البيع ومبيعاتها دون اتصال وسجلات الطباعة والسجل القديم",
    dmCat_items: "الأصناف: الأصناف ووحداتها والباركود والصور والتصنيفات والاستيراد",
    dmCat_parties: "العملاء والموردون والشركاء (يبقى العميل النقدي لنقطة البيع ما دامت المنشأة مفتوحة)",
    dmCat_pos: "نقاط البيع: الأجهزة ورموز التفعيل وأزرار الدفع",
    dmCat_users: "المستخدمون: يُوقفون ويُخرجون (تبقى أسماؤهم في سجل التدقيق) مع صلاحياتهم",
    dmCat_setup: "الإعداد: دليل الحسابات والفروع والمستودعات والخزائن والبنوك والضرائب ومراكز التكلفة والترقيم والإعدادات والشعار (مع كل البيانات ومنشأة معلّقة فقط)",
    dmChoices: "اختيارات صريحة",
    dmBusiness: "المنشأة",
    dmBusiness_keep: "تبقى مفتوحة (يدخل مالكها من جديد)",
    dmBusiness_suspend: "تُعلّق (لا يدخل أحد؛ يبقى السجل)",
    dmOwner: "دخول المالك",
    dmOwner_keep: "يبقى",
    dmOwner_remove: "يُوقف (مع المستخدمين ومنشأة معلّقة فقط)",
    dmSub: "الباقة والاشتراك",
    dmSub_keep: "يبقيان ساريين",
    dmSub_end: "ينتهيان الآن (يبقيان في سجل الفوترة)",
    dmPreview: "معاينة",
    dmStep2: "3. المعاينة",
    dmRows: "سيُحذف {n} سجل",
    dmTable: "الجدول",
    dmCategory: "الفئة",
    dmCount: "السجلات",
    dmKept: "يبقى دائمًا",
    dmKept_organization: "سجل المنشأة",
    dmKept_audit_log: "سجل تدقيق المنشأة",
    dmKept_platform_audit_log: "سجل تدقيق المنصة",
    dmKept_subscriptions: "الاشتراكات (سجل الفوترة)",
    dmKept_reseller_records: "إسنادات الموزعين وأسعارهم ورسومهم",
    dmKept_requests: "طلبات التسجيل والاشتراك",
    dmKept_users: "المستخدمون الذين يستطيعون الدخول",
    dmInFlight: "الآن: {s} جلسة دخول، {g} تصريح بيع دون اتصال ساري، {u} عملية بيع دون اتصال وصلت ولم تُتمّ، {r} نقطة بيع مفعّلة. يُخرج الحذف كل الجلسات، وتُوقف نقاط البيع عند حذف الحركات.",
    dmPosted: "يشمل الحذف {n} سجلًا مرحّلًا أو صادرًا (فواتير وسندات وقيود ومستندات مخزون). على المنشآت في السعودية الاحتفاظ بسجلاتها المحاسبية وفواتيرها الضريبية طوال مدة نظامية (سجلات ضريبة القيمة المضافة ست سنوات على الأقل، وقد تطول للدفاتر التجارية). تحقق من المدة مع المنشأة واحفظ نسخة التصدير قبل الحذف.",
    dmProblems: "لا يمكن الحذف بهذا الاختيار",
    dmProb_setup_needs_suspend: "لا يُحذف الإعداد إلا والمنشأة معلّقة.",
    dmProb_setup_needs_all: "لا يُحذف الإعداد إلا مع كل بيانات المنشأة.",
    dmProb_owner_needs_suspend_and_users: "لا يُوقف دخول المالك إلا مع المستخدمين ومنشأة معلّقة.",
    dmProb_demo_business: "هذه منشأة تجريبية: تُحذف تلقائيًا عند انتهائها.",
    dmNeeds: "{t} ({n} سجل) يشير إلى ما اخترته: أضف {c}.",
    dmStep3: "4. التصدير",
    dmExport: "تنزيل نسخة التصدير",
    dmExported: "نُزّلت نسخة التصدير: {b} بايت، SHA-256 ‏{h}. احتفظ بها: هي طريق الاسترجاع.",
    dmStep4: "5. التأكيد",
    dmTypeName: "اكتب اسم المنشأة: {x}",
    dmPassword: "كلمة مرورك في منصة دلتا",
    dmAckRetention: "نسخة التصدير محفوظة والتزامات حفظ سجلات المنشأة مستوفاة.",
    dmRemove: "حذف البيانات",
    dmDone: "حُذفت. {n} سجل؛ SHA-256 لنسخة التصدير {h}.",
    dmHistory: "عمليات التصدير والحذف السابقة",
    dmStatus_exported: "صُدّرت ولم تُحذف",
    dmStatus_done: "حُذفت",
    dmStatus_failed: "فشلت",
    dmStatus_running: "جارية",
    dmStale: "تغيّرت البيانات: اعرض وصدّر من جديد."
  }
};
